import React from "react";

export default function OrderHeader(props) {
  const { currentConfig, onClickHandler, visible } = props;
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
        backgroundColor: "#000",
        color: "#fff",
        padding: 5,
      }}
      onClick={() => onClickHandler()}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "rows",
          height: 35,
          fontWeight: "bold",
        }}
      >
        <div
          style={{
            backgroundColor: "#F0522E",
            width: 32,
            height: 32,
            marginRight: 15,
          }}
        >
          <svg
            style={{ transform: `rotate(${visible ? 0 : 180}deg)` }}
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
          >
            <path
              d="M11.41 14L16 18.59L20.59 14L22 15.42L16 21.42L10 15.42L11.41 14Z"
              fill="white"
            />
          </svg>
        </div>
        <p>Riepilogo ordine</p>
      </div>
      <div style={{ fontSize: "35px" }}>
        {currentConfig.total > 0 ? (
          `€ ${currentConfig.total.toFixed(2).toString().replace(".", ",")} `
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}
